<template>
	<div class="b-stepperSelect">
		<button
			class="b-stepperSelect__btn b-stepperSelect__btn--down"
			@click="handleStepDownClick"
		>
			<BIcon name="Subtract" size="20px" />
		</button>

		<BSelect
			color="dark"
			menuPlacement="top-start"
			:options="options"
			v-model="innerValue"
		/>

		<button
			class="b-stepperSelect__btn b-stepperSelect__btn--up"
			@click="handleStepUpClick"
		>
			<BIcon name="Add" size="20px" />
		</button>
	</div>
</template>

<script>
import BIcon from "@/components/base/BIcon";
import BSelect from "@/components/base/BSelect";

export default {
	components: {
		BIcon,
		BSelect,
	},
	props: {
		value: {
			type: Number,
			default: 0,
		},
		options: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {};
	},
	computed: {
		reversedOptions() {
			return this.options.slice().reverse();
		},
		innerValue: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
	methods: {
		handleStepDownClick() {
			const prevOption = this.reversedOptions.find(
				(option) => option.id < this.innerValue
			);

			if (prevOption) {
				this.innerValue = prevOption.id;
			}
		},
		handleStepUpClick() {
			const nextOption = this.options.find(
				(option) => option.id > this.innerValue
			);

			if (nextOption) {
				this.innerValue = nextOption.id;
			}
		},
	},
};
</script>

<style lang="scss">
.b-stepperSelect {
	display: flex;
	gap: 2px;

	.b-select__display {
		border-radius: 0;
	}
}

.b-stepperSelect__btn {
	--border-radius: 8px;
	width: 44px;
	background-color: var(--color-neutral-700);
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;

	&--down {
		border-radius: var(--border-radius) 0 0 var(--border-radius);
	}

	&--up {
		border-radius: 0 var(--border-radius) var(--border-radius) 0;
	}
}
</style>
